import type { Theme } from '@mui/material';

export const styles = {
  squareElement: (color: string) => ({
    width: '0.75rem',
    height: '0.75rem',
    marginRight: '0.5rem',
    aspectRatio: '1/1',
    backgroundColor: color,
  }),

  percentageValue: (sizeIsMOrLarger: boolean) => ({
    fontSize: sizeIsMOrLarger ? '2.25rem' : '1.5rem',
  }),

  numberDifference: (sizeIsMOrLarger: boolean) => ({
    display: 'inline-flex',
    alignItems: 'center',
    fontSize: sizeIsMOrLarger ? '1rem' : '0.75rem',
  }),

  benchmarkValue: (theme: Theme) => ({
    color: theme.colors.neutral[700],
  }),
};
